"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedrotate = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedrotate` : '') + (description ? ` desc-brandedrotate` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedrotate"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedrotate"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "m31.7 20.71-.03-.08-.07-.19-.06-.23a2.65 2.65 0 0 1 .38-2.1 10.46 10.46 0 0 0-7.08-2.77v21c5.8 0 10.5-4.71 10.5-10.5 0-1.22-.27-2.86-.66-3.94h-.65c-1.08 0-1.92-.19-2.33-1.2v.01Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.34 25.83c0 5.8 4.7 10.5 10.5 10.5v-21c-5.8 0-10.5 4.7-10.5 10.5Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m43.76 40.84.26-.35.36-.52A57.29 57.29 0 0 0 45 39c.94-1.56 1.7-3.2 2.28-4.9.63-1.85-.33-4-2.13-4.63a3.28 3.28 0 0 0-3.73.98c-.3.36-.51.8-.68 1.23-4.26 10.71-12.69 11.85-15.81 11.9v7.09a23.9 23.9 0 0 0 18.83-9.82Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.34 5.15v14.28c0 1.25-.8 2.38-1.9 2.67-.21.06-.43.1-.65.1h-13.8a2.59 2.59 0 0 1-2.42-1.74l-.07-.19-.06-.23a2.72 2.72 0 0 1 .68-2.5l4.42-4.56a16.94 16.94 0 0 0-8.95-4.78c-.23-.05-.46-.08-.68-.11l-.04-.01-.74-.09-.28-.02a12.7 12.7 0 0 0-.52-.03l-.4-.02V.7h.3a7.08 7.08 0 0 1 .81.04l.66.05.08.01.75.08.63.1h.04a25.78 25.78 0 0 1 3.65.9l1.26.45c.8.32 1.6.7 2.36 1.1l.4.22.2.11c.22.13 1.42.86 1.79 1.13.41.23 3.46 2.88 3.58 3l4.48-4.63a2.5 2.5 0 0 1 2.83-.58c.97.4 1.59 1.38 1.59 2.47v.01Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.73 43.53c-.09 0-12.5-.1-16.2-14.2a13.8 13.8 0 0 1-.35-3.56c0-1.92.27-3.77.83-5.49 1.96-5.94 6.5-10.37 12.34-11.86l.99-.22.6-.1.52-.07.19-.03c.54-.06 1.07-.1 1.61-.1h.66V.67H23.9l-.58.02-.2.02a9.36 9.36 0 0 0-.95.07 15.63 15.63 0 0 0-1.82.26 26.26 26.26 0 0 0-3.86 1.03C8.1 5.03.56 12.75.34 25.76.32 27 .44 28.22.6 29.4c1.72 12.02 11.77 21.25 23.92 21.25l.4-.01v-7.09a9.05 9.05 0 0 1-1.19-.04Z",
    fill: "#F8985A"
  }));
};
var _default = exports.default = brandedrotate;